exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-checkbox {\n    padding: 1rem;\n}\n\n.ant-btn > span.material-design-icon {\n    display: inline-flex;\n    height: 10px;\n}\n\n.ant-calendar-range-quick-selector {\n    padding: 0.5rem 0;\n}\n\n.ant-select-selection__choice__remove {\n    margin-top: 0.5rem;\n}\n\nbody {\n    color: rgba(0,0,0,0.9) !important;\n    font-size: 15px !important;\n}\n", ""]);

// exports
